import React from "react";
import {LazyLoadImage, LazyLoadImageProps} from "react-lazy-load-image-component";

export const LazyImg: React.FC<LazyLoadImageProps> = ({visibleByDefault, ...props}) => (
  <LazyLoadImage {...props} visibleByDefault={visibleByDefault} />
);
